/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import { CodeableConceptFieldsFragmentDoc, QuantityFieldsFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListTerraActivitiesQueryVariables = Types.Exact<{
  input: Types.ListTerraActivitiesInput;
}>;


export type ListTerraActivitiesQuery = { __typename?: 'Query', listTerraActivities: { __typename?: 'ListTerraActivitiesResponse', cursor: string, hasMore: boolean, data: Array<{ __typename?: 'ActivityModel', summary_id: string, start_time: string, end_time?: string | null, activity_type: number, terra_connection_id: string, device_name?: string | null }> } };

export type ListActivityObservationsQueryVariables = Types.Exact<{
  input: Types.GetTerraActivityInput;
}>;


export type ListActivityObservationsQuery = { __typename?: 'Query', getTerraActivity: { __typename?: 'ActivityModel', summary_id: string, observations?: Array<{ __typename?: 'ObservationModel', id?: string | null, status: string, code: { __typename?: 'CodeableConcept', text?: string | null, coding?: Array<{ __typename?: 'Coding', system?: string | null, version?: string | null, code?: string | null, display?: string | null, userSelected?: boolean | null }> | null }, valueQuantity?: { __typename?: 'Quantity', value?: number | null, comparator?: string | null, unit?: string | null, system?: string | null, code?: string | null } | null }> | null } };


export const ListTerraActivitiesDocument = gql`
    query listTerraActivities($input: ListTerraActivitiesInput!) {
  listTerraActivities(input: $input) {
    cursor
    hasMore
    data {
      summary_id
      start_time
      end_time
      activity_type
      terra_connection_id
      device_name
    }
  }
}
    `;
export function useListTerraActivitiesQuery(baseOptions: Apollo.QueryHookOptions<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables> & ({ variables: ListTerraActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>(ListTerraActivitiesDocument, options);
      }
export function useListTerraActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>(ListTerraActivitiesDocument, options);
        }
// @ts-ignore
export function useListTerraActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>;
export function useListTerraActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<ListTerraActivitiesQuery | undefined, ListTerraActivitiesQueryVariables>;
export function useListTerraActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>(ListTerraActivitiesDocument, options);
        }
export type ListTerraActivitiesQueryHookResult = ReturnType<typeof useListTerraActivitiesQuery>;
export type ListTerraActivitiesLazyQueryHookResult = ReturnType<typeof useListTerraActivitiesLazyQuery>;
export type ListTerraActivitiesSuspenseQueryHookResult = ReturnType<typeof useListTerraActivitiesSuspenseQuery>;
export type ListTerraActivitiesQueryResult = Apollo.QueryResult<ListTerraActivitiesQuery, ListTerraActivitiesQueryVariables>;
export const ListActivityObservationsDocument = gql`
    query listActivityObservations($input: GetTerraActivityInput!) {
  getTerraActivity(input: $input) {
    summary_id
    observations {
      id
      status
      code {
        ...CodeableConceptFields
      }
      valueQuantity {
        ...QuantityFields
      }
    }
  }
}
    ${CodeableConceptFieldsFragmentDoc}
${QuantityFieldsFragmentDoc}`;
export function useListActivityObservationsQuery(baseOptions: Apollo.QueryHookOptions<ListActivityObservationsQuery, ListActivityObservationsQueryVariables> & ({ variables: ListActivityObservationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>(ListActivityObservationsDocument, options);
      }
export function useListActivityObservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>(ListActivityObservationsDocument, options);
        }
// @ts-ignore
export function useListActivityObservationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>;
export function useListActivityObservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>): Apollo.UseSuspenseQueryResult<ListActivityObservationsQuery | undefined, ListActivityObservationsQueryVariables>;
export function useListActivityObservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>(ListActivityObservationsDocument, options);
        }
export type ListActivityObservationsQueryHookResult = ReturnType<typeof useListActivityObservationsQuery>;
export type ListActivityObservationsLazyQueryHookResult = ReturnType<typeof useListActivityObservationsLazyQuery>;
export type ListActivityObservationsSuspenseQueryHookResult = ReturnType<typeof useListActivityObservationsSuspenseQuery>;
export type ListActivityObservationsQueryResult = Apollo.QueryResult<ListActivityObservationsQuery, ListActivityObservationsQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListTerraActivities = withQueryResponseHandler(useListTerraActivitiesQuery);
export const useListActivityObservations = withQueryResponseHandler(useListActivityObservationsQuery);
